import { render, staticRenderFns } from "./VmsColumnVisibility.vue?vue&type=template&id=6c106d38&scoped=true"
import script from "./VmsColumnVisibility.vue?vue&type=script&lang=js"
export * from "./VmsColumnVisibility.vue?vue&type=script&lang=js"
import style0 from "./VmsColumnVisibility.vue?vue&type=style&index=0&id=6c106d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c106d38",
  null
  
)

export default component.exports